import { useNavigate } from "react-router-dom";
import { ArrowLeft, BadgeCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { UsersPanel } from "@/components/admin/UsersPanel";
import { RevenuePanel } from "@/components/admin/RevenuePanel";
import { AnnouncementPanel } from "@/components/admin/AnnouncementPanel";
import { PromoCodesPanel } from "@/components/admin/PromoCodesPanel";
import { FailedEmailsPanel } from "@/components/admin/FailedEmailsPanel";
import { AuditLogPanel } from "@/components/admin/AuditLogPanel";

// Panou intern, vizibil DOAR conturilor Fondator (ADMIN_EMAILS).
export default function Admin() {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user?.isFounder) {
    return (
      <div data-testid="admin-forbidden" className="min-h-screen flex flex-col items-center justify-center px-6 text-center">
        <p className="font-semibold text-slate-600">Acces restricționat contului Fondator.</p>
        <button onClick={() => navigate("/")} className="mt-4 text-sm font-semibold" style={{ color: "#12b981" }}>
          Înapoi la Chit
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen pb-10" data-testid="admin-page">
      <header className="px-5 pt-5 pb-8 text-white" style={{ backgroundColor: "#0f1b2d" }}>
        <button
          data-testid="admin-back-btn"
          onClick={() => navigate("/")}
          aria-label="Înapoi"
          className="h-10 w-10 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" strokeWidth={2.5} />
        </button>
        <div className="mt-4 flex items-center gap-2">
          <BadgeCheck className="h-7 w-7 text-amber-400" strokeWidth={2.5} />
          <h1 className="font-heading text-2xl font-black">Panou Fondator</h1>
        </div>
        <p className="text-white/60 mt-1 text-sm">Chit, pe acest mediu.</p>
      </header>

      <div className="px-5 -mt-3">
        <Tabs defaultValue="useri" className="w-full">
          <TabsList className="grid grid-cols-3 w-full rounded-2xl bg-slate-100 p-1 h-auto mb-1">
            <TabsTrigger data-testid="admin-tab-useri" value="useri" className="rounded-xl text-xs py-2 data-[state=active]:bg-white data-[state=active]:shadow-sm font-semibold">Useri</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-venituri" value="venituri" className="rounded-xl text-xs py-2 data-[state=active]:bg-white data-[state=active]:shadow-sm font-semibold">Venituri</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-anunt" value="anunt" className="rounded-xl text-xs py-2 data-[state=active]:bg-white data-[state=active]:shadow-sm font-semibold">Anunț</TabsTrigger>
          </TabsList>
          <TabsList className="grid grid-cols-3 w-full rounded-2xl bg-slate-100 p-1 h-auto mb-5">
            <TabsTrigger data-testid="admin-tab-promo" value="promo" className="rounded-xl text-xs py-2 data-[state=active]:bg-white data-[state=active]:shadow-sm font-semibold">Coduri promo</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-emailuri" value="emailuri" className="rounded-xl text-xs py-2 data-[state=active]:bg-white data-[state=active]:shadow-sm font-semibold">Email-uri</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-jurnal" value="jurnal" className="rounded-xl text-xs py-2 data-[state=active]:bg-white data-[state=active]:shadow-sm font-semibold">Jurnal</TabsTrigger>
          </TabsList>

          <TabsContent value="useri"><UsersPanel /></TabsContent>
          <TabsContent value="venituri"><RevenuePanel /></TabsContent>
          <TabsContent value="anunt"><AnnouncementPanel /></TabsContent>
          <TabsContent value="promo"><PromoCodesPanel /></TabsContent>
          <TabsContent value="emailuri"><FailedEmailsPanel /></TabsContent>
          <TabsContent value="jurnal"><AuditLogPanel /></TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
